
import { useState, useEffect } from 'react';
import { generateAnonymousId } from '@/utils/anonymousId';

export const useAnonymousId = () => {
  const [anonymousId, setAnonymousId] = useState<string | null>(null);
  
  useEffect(() => {
    const fetchAnonymousId = async () => {
      const id = await generateAnonymousId();
      setAnonymousId(id);
    };
    
    fetchAnonymousId();
  }, []);
  
  return { anonymousId };
};
